import { render } from "./AppNotificationBar.vue?vue&type=template&id=544847da&scoped=true"
const script = {}

import "./AppNotificationBar.vue?vue&type=style&index=0&id=544847da&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-544847da"]])

export default __exports__